/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="client.module.ts" />
/// <reference path="../../components/common/businessinfo.service.ts" />

module Meevo.Plugins.Client {
    import ClientIntakeFormService = Meevo.Plugins.ClientIntakeForm.ClientIntakeFormService;

    class ClientController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public emlployeeDetails: any = null;
        public newPhoneNumber: any = null;
        public isNotificationEnabled: boolean;

        static $inject = [
            "meevo.AppSettings",
            "$http",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.hostedPage.HostedPageService",
            "meevo.components.common.AddressFieldsService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "$q",
            "$translate",
            "meevo.components.busy.BusyService",
            "meevo.components.common.RecentService",
            "$timeout",
            "$cookies",
            "meevo.components.common.PrintService",
            "meevo.plugins.client.RecentClientsService",
            "meevo.components.common.ImageGalleryService",
            "meevo.components.common.BusinessInfoDataService",
            "$sce",
            "meevo.plugins.docsAndForms.DocsAndFormsService",
            "$locale",
            "meevo.plugins.clientIntakeForm.ClientIntakeFormService",
            "$mdSidenav",
            "$filter",
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $http: angular.IHttpService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected hostedPageService: Meevo.Components.HostedPage.IHostedPageService,
            protected addressFieldsService: Meevo.Components.Common.IAddressFieldsService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $q: angular.IQService,
            protected $translate: angular.translate.ITranslateService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected recentService: Meevo.Components.Common.RecentService,
            protected $timeout: angular.ITimeoutService,
            protected $cookies: angular.cookies.ICookiesService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected recentClientsService: Meevo.Plugins.Client.RecentClientsService,
            protected imageGalleryService: Meevo.Components.Common.IImageGalleryService,
            protected businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService,
            protected $sce,
            protected docsAndFormsService: Meevo.Plugins.DocsAndForms.DocsAndFormsService,
            protected $locale: angular.ILocaleService,
            protected clientIntakeFormService: ClientIntakeFormService,
            protected sideContextMenu: Meevo.IMeevoSideMenu,
            protected $filter: angular.IFilterService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService, {
                use: true,
                appAreaEnum: Meevo.Model.AppAreaEnum.Client,
                udfNoun: Meevo.Model.NounEnum.ClientUDF
            });

            this.targetView = Meevo.Model.ClientSearchView.FromDataMaintenance;
            this.searchFallbackCriteria = {
                isGlobal: true
            };

            if (this.identityService.inCentralOfficeMode()) {
                if (!this.searchContextCriteria) {
                    this.searchContextCriteria = {
                        includeActive: true,
                        view: Meevo.Model.ClientSearchView.FromDataMaintenance,
                        coSearchType: null,
                        coBusinessTypeId: null,
                        coFilterByLocationId: null,
                        coSearchResultFilter: Meevo.Model.CoSearchResultsFilter.All,
                        location: null,
                        businessType: null,
                        maintenanceMode: true,
                        isGlobal: true
                    };
                }
                else {
                    this.searchContextCriteria["isGlobal"] = true;
                }
            }

            this.sideContextMenu = sideContextMenu;

            var sendMessageListener = this.$rootScope.$on(Meevo.Components.Common.Messages.SEND_MESSAGE, this.viewClientHistoryNoteModalInvoker);
            $scope.$on('$destroy', () => {
                sendMessageListener();
            });
        }
        //isSearchGlobal = false;
        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
            // TODO: Review if there is a better place to put this to reduce the boilerplate for this createContext() function in all controllers
            // Start busy indicator just in case this is first time creating the context and the request for checkSection takes any time...
            this.busyService.start();
            this.securityService.checkSection("DATA:Client").then(() => {
                // Stop the global busy indicator
                this.busyService.stop();
                if (this.contextParams.params && this.contextParams.params.employeeClientLinkDetails && this.contextParams.params.actionState == Meevo.Model.MaintenanceFormState.Adding) {
                    this.emlployeeDetails = this.contextParams.params.employeeClientLinkDetails;
                }

                if (!this.newPhoneNumber && this.contextParams.params && this.contextParams.params.newPhoneNumber && this.contextParams.params.actionState == Meevo.Model.MaintenanceFormState.Adding) {
                    this.newPhoneNumber = this.contextParams.params.newPhoneNumber;
                }
                else this.newPhoneNumber = null;

                // Get main notification setting for context initialization
                let settings = { settings: [Meevo.Model.BusinessInfoSettingEnum.EnableAppointmentNotification] };
                this.dataService.customMethodData('api/location/maintenance/' + this.identityService.locationId, 'POST', settings)
                    .then((res) => {
                        this.isNotificationEnabled = Number(res.data.settings[0].effectiveValue) == 1 ? true : false;
                    })
                    .finally(() => {
                        // Once setting is determined, context can be initialized
                        this.initializeContext();
                    });
            });
        }

        initializeContext(): void {
            let context = new ClientContext(
                this.appSettings,
                this.dataService,
                this.modalService,
                this.identityService,
                this.loggingService,
                this.securityService,
                this.hostedPageService,
                this.addressFieldsService,
                this.trackingService,
                this.recentService,
                this.customDataContextConfig,
                this.contextParams,
                this.busyService,
                this.$q,
                this.$scope,
                this.$translate,
                this.$rootScope,
                this.$cookies,
                this.printService,
                this.recentClientsService,
                this.imageGalleryService,
                this.emlployeeDetails,
                this.newPhoneNumber,
                this.isNotificationEnabled,
                this.$sce,
                this.businessInfoDataService,
                this.docsAndFormsService,
                this.$locale,
                this.clientIntakeFormService,
                this.sideContextMenu,
                this.$filter
            );

            this.context = context;
            super.createContext();
            this.context.searchResultItemTemplate = "{{lastName}}, {{firstName}} - {{format primaryPhoneNumber type='phoneLastFour'}}";
            this.context.activate(this.selectedItemId, this.initialEditSection, null, this.initialEditSubSection);
            if (this.contextParams.params && this.contextParams.params.clientDisplayName) {
                this.context.headerContent = this.contextParams.params.clientDisplayName;
            }
            if (this.initialEditSection === "SECTION_CLIENT_NOTES" || this.initialEditSection === "SECTION_CLIENT_VISIT_NOTES" && this.contextParams.params) {
                // Workaround to reload section template, even when displaying the same section previously displayed for another client
                if (this.context.selectedSection.handlesOwnCrud) {
                    context.setLoadingInProgress(true);
                    this.$timeout(() => {
                        context.setLoadingInProgress(false);
                    });
                }
            }
            this.context.deactivate = () => {
                this.visualState = Model.MaintenanceFormVisualState.Search;
            }

            this.manageSectionRouting(this.contextParams);

            this.$scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams, options) => {
                if (toState.name == 'client') {
                    this.manageSectionRouting(this.contextParams);

                    let mainSection = this.context.selectedSection as MainSection;
                    let sectionName = mainSection.constructor['name'];
                    /*  Make sure that selectedSection is MainSection   */
                    if (mainSection && sectionName == 'MainSection') {
                        mainSection.setHadFirstVisitAndHadTransaction(null);
                    }
                }

            });
            this.$scope.$watch(() => this.visualState, (newState: Model.MaintenanceFormVisualState) => {
                if (newState === Model.MaintenanceFormVisualState.Search && this.contextParams.params && this.contextParams.params.clientAlertType) {
                    this.contextParams.params.clientAlertType = null;
                    this.context.setFocusOnField(this.contextParams.params.clientAlertType, this.contextParams.params.actionState);
                }
            });
        }

        manageSectionRouting(contextParams: Meevo.IContextParams): void {
            if (contextParams && contextParams.params) {
                // for client alert types
                if (contextParams.params.clientAlertType in Model.ClientAlertTypeEnum) {
                    // get the target section id
                    var sectionId = this.getClientAlertSectionId(this.contextParams.params.clientAlertType);
                    // select the target section
                    if (sectionId) {
                        _.forEach(this.context.sections, (section: any) => {
                            if (section.sectionId === sectionId) {
                                this.context.selectSection(section);
                                return;
                            }
                        });
                    } else {
                        // select the top section
                        this.context.selectSection(_.first(this.context.sections));
                    }
                    // place in edit mode if alert is for missing information
                    if (contextParams.params.clientAlertType in
                        [
                            Model.ClientAlertTypeEnum.MissingContactInfo,
                            Model.ClientAlertTypeEnum.MissingEmailAddress,
                            Model.ClientAlertTypeEnum.MissingPhoneNumber,
                            Model.ClientAlertTypeEnum.MissingReferral
                        ]) {
                        this.context.editExternal();
                    }
                }
                // apply focus on target field if in edit mode
                if (contextParams.params.actionState == Meevo.Model.MaintenanceFormState.Editing) {
                    this.context.setFocusOnField(contextParams.params.clientAlertType, contextParams.params.actionState);
                }
                else if (contextParams.params.initialEditSubSection === 'APPOINTMENT_HISTORY' && !!contextParams.params.filter) {
                    this.context.setFilter(contextParams.params.filter);
                }
            }
        }

        getClientAlertSectionId = function (alert): number {
            switch (alert) {
                case Meevo.Model.ClientAlertTypeEnum.HasNotes:
                    return 1;
                case Meevo.Model.ClientAlertTypeEnum.HasActiveGiftCard:
                    this.context.setMode(Model.MaintenanceFormState.Readonly);
                    return 6;
            }
            return;
        }
        async applyParams(params) {
            await super.applyParams(params);
            if (Model.Guard.isSomething(params)) {
                let context = (<ClientContext>this.context);
                let sectionContentKey = null;
                let subSectionContentKey = null;
                if (Model.Guard.isNothing(context))
                    return;

                if (this.emlployeeDetails != null) {
                    context.employeeLinkDetails = this.emlployeeDetails;
                }

                if (this.newPhoneNumber != null) {
                    context.newPhoneNumber = this.newPhoneNumber;
                }

                // Activate with editing id with mode
                if (Model.Guard.isSomething(params.id)) {
                    var sectionId = this.getClientAlertSectionId(params.clientAlertType);
                    if (sectionId && context.selectedSection.sectionId != sectionId) {
                        var section = _.find(context.sections, (section: any) => {
                            return section.sectionId === sectionId;
                        });
                        sectionContentKey = section.displayNameContentKey;

                        if (section) {
                            context.selectSection(section);
                        }
                    }
                    if (!sectionId || !sectionContentKey) {
                        sectionContentKey = params.initialEditSection;
                        subSectionContentKey = params.initialEditSubSection;
                    }
                    context.activate(this.selectedItemId, sectionContentKey, null, subSectionContentKey);
                    if (params.actionState) {
                        context.setMode(params.actionState);
                    }
                    else {
                        context.setMode(Model.MaintenanceFormState.Editing);
                    }
                }
                // Activate with new client with mode
                else {
                    // Find main section
                    let section: any;
                    if (params.initialEditSection) {
                        section = _.find(context.sections, (s: any) => { return s.displayNameContentKey === params.initialEditSection });
                    }
                    if (!section) {
                        section = _.find(context.sections, (s: any) => { return s.displayNameContentKey === 'SECTION_CLIENT_MAIN' });
                    }
                    if (Model.Guard.isSomething(section)) {
                        section.createInstance(null);
                        context.headerContent = '';
                        context.activate(null, section.displayNameContentKey, null, params.initialEditSubSection);
                        if (params.actionState) {
                            context.setMode(params.actionState);
                        }
                        else {
                            context.setMode(Model.MaintenanceFormState.Adding);
                        }
                    }
                }
            }
        }

        /**
        * Callback function from infinity scroll(Page Result).
        * Go through clients and check if they sent to Transworld
        * @param {number} pageNumber
        * @param {any} clients
        */
        updateClientsInfo(pageNumber, clients: any): void {
            if (!clients || !clients.length) return;

            this.dataService.customMethodData(`/${Meevo.AppSettings.Default.API_ROOT}/settings/transworldFields/`, 'GET', null)
                .then(res => {
                    if (!res.data.enableTransworld) return [];

                    return this.dataService.customMethodData(
                        `/${Meevo.AppSettings.Default.API_ROOT}/Transworld/Client/List/`,
                        'POST',
                        { clients: clients.map(client => client.id) }
                    );
                }).then(res => {
                    if (!res.data || !res.data.length) return;

                    const formatedClientsList: any = _.indexBy(res.data, 'clientId');
                    clients.forEach(client => {
                        client.isSentToTransworld = formatedClientsList[client.id].isSentToTransworld;
                    });
                });

        }

        preValidation(id): ng.IPromise<boolean> {
            if (id != null) {
                return this.dataService.customMethodData(`/${Meevo.AppSettings.Default.API_ROOT}/${this.appSettings.API_ENDPOINTS.client}/${id}/PreValidation`, 'GET', null)
                    .then((response) => {
                        if (response.data.objectState == Meevo.Model.ObjectStateEnum.Purged) {
                            // show modal that data is purged, then close to Search screen, then switch back to caller
                            this.modalService
                                .alert("MESSAGE_CLIENT_HAS_BEEN_PURGED")
                                .then(() => {
                                    var cb = Model.Guard.isSomething(this.contextParams) ? this.contextParams.params : null; //this may be overwritten during closecontext, so cache it temporarily here.
                                    if (cb && cb.callbackState) {
                                        this.$rootScope.$broadcast('closeContext', this.$state.current, cb.callbackState);
                                    }
                                });
                            return false;
                        }
                        return true;
                    });
            }
            return this.$q.resolve(true);
        }

        viewClientHistoryNoteModalInvoker = (event, data: any) => {
            if (this.context
                && data.stateName === 'client'
                && data.stateParams
                && data.stateParams.item
                && data.stateParams.id === 'history:package-history:view-transaction-notes') {
                (this.context as ClientContext).viewClientHistoryNoteModal(data.stateParams.item);
            }
        };

    }
    angular.module("meevo.plugins.client")
        .controller("meevo.plugins.client.ClientController", ClientController);
}
